import fetchDb from "@/utils/customRequestFunction";
import { AdminSliceCreator, AdminStoreState } from "./useAdminStore";
import { produce } from "immer";
import { LearnMore } from "@/types/productTypes";

export type LearnMoreStore = {
   allLearnMore: LearnMore[];
   fetchLearnMore: () => Promise<void>;
};

export const createLearnMoreSlice: AdminSliceCreator<LearnMoreStore> = (
   set
) => ({
   allLearnMore: [],
   fetchLearnMore: async () => {
      const response = await fetchDb.get("/api/learn-more");
      console.log("response", response);
      set(
         produce((state: AdminStoreState) => {
            state.allLearnMore = response;
         })
      );
   },
});
